import CustomStartpageElement from '@/Components/CustomStartpageElement/CustomStartpageElement';
import CustomStartpageElementRegistry from '@/Components/CustomStartpageElement/CustomStartpageElementRegistry';

export default class ActivityFeedStartpageElement extends CustomStartpageElement {
    protected getContent(): JQuery<HTMLElement> {
        const $content = $('<div>');
        this.applyBindings($content, {
            control: {
                uiGenerator: 'ActivityFeed',
                viewModel: this.customViewModel
            }
        });
        return $content;
    }
}

CustomStartpageElementRegistry.register('ActivityFeed', ActivityFeedStartpageElement);